import React from "react";
import { Box, Flex, Text, Heading } from "@chakra-ui/react";

type Props = {
  name?: string;
  description?: string;
  onClick?: () => void;
  icon?: React.ReactElement;
};

const Role = ({
  name,
  description,
  onClick,
  icon,
}: Props): React.ReactElement => (
  <Box
    position="relative"
    transitionTimingFunction="cubic-bezier(.4,0,.2,1)"
    transitionDuration=".3s"
    transitionProperty="transform,box-shadow"
    _hover={{
      transform: "scale(1.05)",
      boxShadow:
        "0 0 transparent, 0 0 transparent, 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
    }}
    _before={{
      content: '""',
      width: "90%",
      bg: "light.100",
      boxShadow: "0 3px 20px rgb(0,0,0,0.04)",
      position: "absolute",
      left: 0,
      right: 0,
      ml: "auto",
      mr: "auto",
      mt: ".75rem",
      h: "100%",
      borderRadius: ".375rem",
    }}
  >
    <Flex
      alignItems="center"
      padding="1rem"
      borderRadius=".375rem"
      border="1px solid"
      borderColor="light.300"
      cursor="pointer"
      boxShadow="0 3px 5px rgb(0,0,0,0.03)"
      textAlign="center"
      position="relative"
      bg="white"
      onClick={onClick}
    >
      <Flex
        mr={5}
        color="main.800"
        w="80px"
        h="80px"
        align="center"
        justify="center"
        shrink={0}
      >
        {icon}
      </Flex>
      <Box textAlign="left">
        <Heading size="lg" mb="0">
          {name}
        </Heading>
        <Text color="text.500" mt={2}>
          {description}
        </Text>
      </Box>
    </Flex>
  </Box>
);

export default Role;
